<template>
  <div class="overlay-layout">
    <div class="overlay-layout__content">
      <slot name="main" />
    </div>
    <div
      :class="classNames"
      class="overlay-layout__sidebar"
    >
      <hidden-elements-container
        :position="position"
        :hide-after-milliseconds="hideAfterMilliseconds"
        :default-open="defaultOpen"
        :click-outside="clickOutside"
        :buttonText="buttonText"

        @toggle="onToggle"
      >
        <slot name="sidebar" />
      </hidden-elements-container>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HiddenContainerOverlay',

  props: {
    /**
     * To which side is the container positioned<br />
     * `left` or `right`
     */
    position: {
      type: String,
      required: false,
      default: 'right',
      validator: (value) => ['right', 'left'].includes(value),
    },

    /**
     * Hide the container after amount of milliseconds
     */
    hideAfterMilliseconds: {
      type: Number,
      required: false,
      default: 0,
    },

    /**
     * Should the container remain open when visiting the page
     */
    defaultOpen: {
      type: Boolean,
      required: false,
      default: false,
    },

    /**
     * Hide container on click outside
     */
    clickOutside: {
      type: Boolean,
      required: false,
      default: true,
    },

    /**
     * The text in the toggle button to open the container
     */
    buttonText: {
      type: String,
      required: false,
      default: 'Bekijk de content',
    },
  },

  data() {
    return {
      isHidden: !this.defaultOpen,
    };
  },

  computed: {
    classNames() {
      const classNames = [
        `--${this.position}`,
      ];

      if (this.isHidden) {
        classNames.push('--hide');
      }

      return classNames;
    },
  },

  methods: {
    onToggle(isHidden) {
      if (this.isHidden) {
        this.$store.commit('list/deselect');
      }

      this.isHidden = isHidden;
    },
  },
};
</script>

<style lang="scss" scoped>
  .overlay-layout {
    height: calc(100vh - 70px);
    position: relative;
    width: 100vw;

    &__content {
      height: 100%;
    }

    &__sidebar {
      bottom: 0;
      // stylelint-disable jeroensmits/declaration-use-variable
      margin-bottom: 33px;
      max-width: 90%;
      position: fixed;
      top: 0;
      transition: transform .8s;
      width: 400px;
      z-index: get-z-index();

      &.\--right {
        right: 0;

        @include mq($until: tablet) {
          left: 0;
          right: auto;
        }
      }

      &.\--left {
        left: 0;
      }

      &.\--hide {
        &.\--right {
          transform: translateX(100%);

          @include mq($until: tablet) {
            transform: translateX(-100%);
          }
        }

        &.\--left {
          transform: translateX(-100%);
        }
      }
    }

    @include mq($until: tablet) {
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
    }
  }
</style>
